export default function menuOpen() {
    const burger = document.getElementById('tb-burger');
    const overlay = document.getElementById('tb-nav-overlay');
    if (!burger || !overlay) return;

    function open() {
        overlay.classList.add('open');
        burger.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    function close() {
        overlay.classList.remove('open');
        burger.classList.remove('open');
        document.body.style.overflow = '';
    }

    burger.addEventListener('click', () => {
        overlay.classList.contains('open') ? close() : open();
    });

    overlay.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', close);
    });
}
